import { useEffect, useState } from 'react'
import { WContainer } from '@components/atoms'
import { PaginaNode } from '@gql/graphql'
import { Button } from '@components/atoms'
import { PlaceholderReact } from '@components/molecules'
import { GenericHero, Page, Prefooter } from 'components/organisms'
import useTrans from '@hooks/useTrans'
import { useRouter } from 'next/router'
import Script from 'next/script'
import { getBaseHostUrl } from '@utils/index'
import styles from './TaxesTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
}

const TaxesTemplate = (props: Props) => {
  const { pagina = undefined } = props
  const defaultContent1 = pagina?.pagebuilders?.find((x) => x.key === 'main') ?? null
  const t = useTrans()
  const router = useRouter()

  const [loaded, setLoaded] = useState(false)


  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero pagina={pagina} />
        <div className={styles.placeholderContent}>
          <PlaceholderReact
            contentTypeId={pagina.model}
            objectId={pagina.pk}
            pkey={'main'}
            serverSideContent={defaultContent1}
          />
        </div>
        <WContainer>
          <div className={styles.buttonContainer}>
            <Button
              id="wizard-btn"
              label={t('SUBMIT TAX EXEMPTION')}
              newPage={true}
              external={true}
              href='https://app.certexpress.com/?c=4b6b5a3747794d524e574735726d6d314b5a7a31:68c9392c03e02dc03c852f7b5862c54c'
            />
          </div>
        </WContainer>
        <Prefooter />
        {/* <Script src="https://ecwportal.vertexsmb.com/wizard/button.js" /> */}
      </main>
    </Page>
  )
}

export default TaxesTemplate
